<template>
	<div class="join-entry-page">
		<div class="bg-wrap">
			<img class="bg-img" src="http://pic5.40017.cn/i/ori/1ODBemWX3c4.png" />
		</div>

		<section class="entry-list">
			<button class="entry-btn" :style="{backgroundImage: `url(${campus})`}" 
			type="button" @click="goToInternshipHire">
				在校应届生
			</button>
			<button class="entry-btn" :style="{backgroundImage: `url(${social})`}"  type="button" @click="goToCampusHire">
				在校实习生
			</button>
		</section>
	</div>
</template>

<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

const campus='http://pic5.40017.cn/i/ori/1MG9X8UJcLm.png'
const social='http://pic5.40017.cn/i/ori/1MGsgEdNY7m.png'

const goToInternshipHire = () => {
	router.push({
		path: "/joinUs/jobList",
		query: {
			recruitType: "campusGraduate",
		},
	});
};

const goToCampusHire = () => {
	router.push({
		path: "/joinUs/jobList",
		query: {
			recruitType: "campusIntern",
		},
	});
};
</script>

<style lang="scss" scoped>
.join-entry-page {
	min-height: calc(100vh - 180rem);
	padding: 0 32rem;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	// background: url("http://pic5.40017.cn/i/ori/1N50TgvQp6o.png") no-repeat center top;
	// background-size: cover;
}

.bg-wrap {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}

.entry-list {
	display: flex;
	flex-direction: column;
	gap: 36rem;
	width: 100%;
}

.entry-btn {
	width: 100%;
	height: 180rem;
	border: none;
	text-align: left;
	color: #fff;
	font-size: 52rem;
	line-height: 180rem;
	padding: 0 80rem;
	border-radius: 20rem;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-color: transparent;
}
</style>
